import { FormManager } from 'react-form-state-manager';
import camelCase from 'lodash/camelCase';

import { DiscountType } from '__generated__/graphql';
import UI from '../../../../common/UI';
import useCurrencyInput from '../../../../common/useCurrencyInput';
import useNumberInput from '../../../../common/useNumberInput';

interface DiscountData {
  type: DiscountType;
}

export interface DiscountValueInputProps {
  form: FormManager<DiscountData>;
  prefix?: string;
}

const DiscountValueInput = ({ form, prefix }: DiscountValueInputProps) => {
  const currencyInput = useCurrencyInput();
  const numberInput = useNumberInput();

  const key = [prefix, 'value'].filter((v) => !!v).join('.');

  if (form.values.type === DiscountType.absolute) {
    return (
      <UI.CurrencyInput
        {...form.text(key, { inputHandler: {
          parse: currencyInput.parse,
          format: currencyInput.value,
        } })}
        id={`DiscountValue_${camelCase(key)}`}
      />
    );
  }

  return (
    <UI.InputWrapper>
      <UI.Input
        id={`DiscountValue_${camelCase(key)}`}
        {...form.text(key, { inputHandler: numberInput({ min: 0, max: 100, decimals: 0 }) })}
        placeholder="0"
      />
      <span>%</span>
    </UI.InputWrapper>
  );
};

export default DiscountValueInput;
